import { Action } from '@ngrx/store';

export class MyCapitalActions implements Action {
  public static getMyCapitalKeys: string = '[MYCAPITAL] GET_KEYS';
  public static getMyCapitalKeysError: string = '[MYCAPITAL] GET_KEYS_ERROR';
  public static getMyCapitalKeysSuccess: string =
    '[MYCAPITAL] GET_KEYS_SUCCESS';

  constructor(public type: string, public payload?: any) {}
}
